import { useNavigate } from 'react-router-dom';
import SbuTable from '../components/SbuTable';

const SBU = () => {
     const navigate = useNavigate();

     const handleAddClick = () => {
          navigate('/sbu/add');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>SBU Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add SBU
                    </button>
               </div>
               <SbuTable />
          </div>
     );
};

export default SBU;